module.exports = __webpack_public_path__ + "img/xsj-log2-4.ebcbee79.png";